import * as React from 'react'

import createContext from 'modules/core/hooks/createContext'
import { useCallback } from 'modules/core/hooks/useCallback'

import type { TemplateWeeksDispatch } from './reducers/templateWeeks'
import templateWeeksReducer, {
  TemplateWeeksState,
  initialTemplateWeeksState,
} from './reducers/templateWeeks'

type Context = [TemplateWeeksState, TemplateWeeksDispatch]

const { context: TemplateWeeksContext, hook: useTemplateWeeks } = createContext<Context>()

const TemplateWeeksProvider = ({ children }: React.PropsWithChildren<object>) => {
  const memoizedReducer = useCallback(templateWeeksReducer, [])
  const [state, dispatch] = React.useReducer(memoizedReducer, initialTemplateWeeksState())

  return (
    <TemplateWeeksContext.Provider value={[state, dispatch]}>
      {children}
    </TemplateWeeksContext.Provider>
  )
}

export { TemplateWeeksProvider, useTemplateWeeks }
